import React from 'react'
import UrbanLogo from '../Asset/urban-fit-logo.png'

function Shopcares() {
  return (
    <main className='container-pages bg-light"'>

<div className="shopcares-section m-5 fw-bold">
<h5 class="text-center mb-4 p-2 fw-bold fs-2">
      <img src={UrbanLogo} alt="main-logo" className='main-logo'/>
        CARES</h5>
      <p>We at UrbanFit Clothings cares about the environment. Even at a small scale company, We hope to make an impact to the environment as we believe in "One Earth. One Home."
        This means we are using Eco-friendly clothings made from natural fibers, No pesticides or chemicals used but breathable and soft.
      </p>

      <p><strong>What is Eco-Friendly Clothing anyway?</strong> It starts in our warehouse and we decided to make an eco-friendly fabrics that are organic cotton (is grown without poisonous pesticides), hemp, linen, wool, and silk.</p>

      <p><strong>What it is for our customers?</strong> We explained our side, now we are giving reasons for you to make a contributions to the environment by choosing our products:</p>
      <ul>
        <li><h5>Good for your health</h5></li>
        <p>Production of typical cotton requires a lot of <strong>Chemicals</strong> - to scare off the animals, to prevent cotton from getting any kind of diseases etc.
        Those are the chemicals that may be the reason for bad allergies, constant itching, and redness in most unexpected places.
        Buying our eco-friendly clothes, you can forget about the issue. We perfected our crafted based on decades of experiences. Moreover, organic fabrics feel so much better on your <strong>skin.</strong></p>

        <li><h5>Good quality</h5></li>
        <p>If washed wrong, it will be impossible to wear and sometimes discoloration spoiled it. Our eco products are proven that can last long for you to enjoy.</p>
        <li><h5>It is personal</h5></li>
        <p>Our eco-friendly products are not being produced on the assembly lines of the factory. You can be sure that your piece of clothing will be much more unique than others. Thats why we believe there's a style in every story. Be bold. Be you!</p>
        <li><h5>You spread awareness</h5></li>
        <p>You can educate about the others and be an example to present our products made from natural fibers and make people rethink their brand favorites as well. Inspire them with your own styles!</p>
        <li><h5>Your contribution</h5></li>
        <p>Fashion that is not sustainable adds up to carbon dioxide emissions, poisoning the soil and enriching the landfills with plastic. The jacket one buys at a mass-market shop will not leave the planet in 200 years. 
          The chemicals that are used to dye the clothes and protect the cotton from animals will pollute water, sub-layers of soil and air all at once so buying our eco friendly products can surely help our cause even if its small step we still make a big difference.</p>
      </ul>
      <a href="#faq"><div className='scroller'></div></a>
      </div>



     <section className='faq-container bg-light'>
      <h5 class="text-center mb-4 p-2 fw-bold fs-2">
      <img src={UrbanLogo} alt="main-logo" id="faq" className='main-logo'/>
        FAQ</h5>
      <p class="text-center mb-5 bg-light">
       <strong>Find the answers for the most frequently asked questions below</strong> 
      </p>
    
      <div class="row">
        
        <div class="col-md-6 col-lg-4 mb-4 bg-light">
          <h6 class="mb-3"><i class="far fa-paper-plane pe-2 bg-light"></i><strong class="fs-5">My order is delayed. When will I receive it?</strong></h6>
          <p class="bg-light">
            <strong><u>Most packages are delivered on time.</u></strong> On rare occasions, orders may be delivered after the estimated delivery date.
            <p>Please note that delays may be caused by:</p>
           <ul>
             <li>Late fulfillment in warehouse</li>
             <li>Delayed handover to courier</li>
             <li>Seasonal peak high volume orders</li>
             <li>Inclement weather</li>
             <li>Road closures</li>
             <li>Logistical problems.</li>
           </ul>
           <p>If order is late. Please contact us using the form below</p>
          </p>
        </div>
    
        <div class="col-md-6 col-lg-4 mb-4">
        <h6 class="mb-3"><i class="far fa-paper-plane pe-2 bg-light"></i><strong class="fs-5">What is the Cancellation Policy of UrbanFit-Store?</strong></h6>
          <p class="bg-light"> 
            <strong><u>Urban Fit Cancellation Policy</u></strong> 
            <ul>
              <li>Orders can only be cancelled before it has been Packed</li>
              <li>Successful cancelled item can no longer retract cancellation request</li>
              <li>If you order got cancelled and the discount voucher you used has not yet expired, you can still used it for another order</li>
              <li>In case of prepayment via credit/debit cards, your money will be refunded automatically with 1 or 2 billing cycles depending on your bank policy</li>
            </ul>
          </p>
        </div>
    
        <div class="col-md-6 col-lg-4 mb-4">
        <h6 class="mb-3"><i class="far fa-paper-plane  pe-2 bg-light"></i><strong class="fs-5">My order status in email is delivered but i did not receive?</strong></h6>
        <ul>
          <li>First, double check your delivery address indicated in the order to ensure that it is correct.</li>
          <li>Check other possible recipients, check with your guard, receptionist, or other lobby personnel who could recieved orders on your behalf</li>
          <li>
        If your order status is delivered but you still didn't received a package, you may check your track numbers indicated in email and file for a refund request if you cannot locate your item.
          </li>
          <li>Please contact us using the form below and choose refund as an issue </li>
          </ul>
        </div>
    
        <div class="col-md-6 col-lg-4 mb-4">
        <h6 class="mb-3"><i class="far fa-paper-plane  pe-2 bg-light"></i><strong class="fs-5">What are the available shipping options?</strong></h6>
        <ul>
          <p class='text-decoration-underline p-0'>Standard Delivery</p>
          <li class="pb-1">Standard Delivery - Available nationwide for as low as $10</li>
          <li class="pb-1">Express Delivery - What we call same-day delivery for orders made before 1 PM and next-day deliver for orders made after 1 PM. (Not available internationally)</li>
          <li>Collection Point - New delivery option that allows you to pick up your orders in your chosen location.</li>
        </ul>
        </div>
    
        <div class="col-md-6 col-lg-4 mb-4">
        <h6 class="mb-3"><i class="far fa-paper-plane  pe-2 bg-light"></i><strong class="fs-5">Do you deliver during weekends and holidays?</strong></h6>
          <p><strong><u>YES!</u>.</strong>Orders can be delivered during weekend or holidays. Once the order is in transit, you will be able to receieve
          an email and mobile text.</p>
          <p>Please double check your shipping address, contact number and ensure that your are available upon delivery</p>
        <p>Kindly keep your communication lines open as Urban-Fit Clothings courier may reach out to you upon their arrival in your shipping address.</p>
        </div>
    
        <div class="col-md-6 col-lg-4 mb-4">
        <h6 class="mb-3"><i class="far fa-paper-plane  pe-2 bg-light"></i><strong class="fs-5">Can I use a credit card which is not under my name to place an order?</strong></h6>
          <p class="bg-light">
            No, for security purposes, Urban Fit Clothings only allows orders from Credit Card Holder both local and international. 
            Please make sure to use your own Credit Card when creating a transaction in our Bag transaction page. 
          </p>
        </div>
        <a href="#contactformid"><div className='scroller'></div></a>
      </div>


    </section>
    <div class="container"> <div class=" text-center mt-5 ">
        <h2 class="bg-light">Still have questions?</h2>
        <h2 class="bg-light">Get in touch</h2>
    </div>
    <div class="row">
        <div class="col-lg-7 mx-auto mb-5">
            <div class="card mt-2 mx-auto p-4 bg-dark">
                <div class="card-body bg-light">
                    <div class="container">
                        <form id="contact-form" role="form">
                            <div class="controls">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="form_name" class="pb-1" id="contactformid">Firstname</label> <input id="form_name" type="text" name="name" class="form-control" placeholder="Please enter your firstname *" required="required" data-error="Firstname is required."/> </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="form_lastname" class="pb-1">Lastname</label> <input id="form_lastname" type="text" name="surname" class="form-control" placeholder="Please enter your lastname *" required="required" data-error="Lastname is required."/> </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="form_email">Email</label> <input id="form_email" type="email" name="email" class="form-control" placeholder="Please enter your email *" required="required" data-error="Valid email is required."/> </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="form_need" class="pb-1">Please specify your need</label> <select id="form_need" name="need" class="form-control" required="required" data-error="Please specify your need.">
                                                <option value="" selected disabled>--Select Your Issue--</option>
                                                <option>Request Invoice for order</option>
                                                <option>Request order status</option>
                                                <option>Haven't received item yet - Refund</option>
                                                <option>Others</option>
                                            </select> </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group"> <label for="form_message">Message</label> <textarea id="form_message" name="message" class="form-control" placeholder="Write your message here." rows="4" required="required" data-error="Please, leave us a message."></textarea> </div>
                                    </div>
                                    <div class="col-md-12"> <input type="submit" class="btn btn-dark btn-send pt-2 btn-block" value="Send Message"/> </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div> 
        </div> 
    </div>
</div>

    </main>
  )
}

export default Shopcares